import * as React from 'react';
import { connect } from 'react-redux';
import { PrimaryButton } from 'office-ui-fabric-react';
import { ApplicationState } from "../../../../store/index";
import { actionCreators } from "../../../../store/integration/Office365Store";
import PromptConfirmationDialog from '../../../common/PromptConfirmationDialog';

type OwnProps = {
    actions: {
        link: () => void;
    };
    dismissPanel?: () => void;
}

type StateProps = {
}
type Props = OwnProps & StateProps & typeof actionCreators;

const OktaOrganizationConnectControl = (props: Props) => {
    const [showConfirmation, setShowConfirmation] = React.useState<boolean>();
    const toggleShowConfirmation = React.useCallback(() => setShowConfirmation(!showConfirmation), [showConfirmation]);

    const linkToOrganization = React.useCallback(() => {
        props.actions.link();
        props.dismissPanel?.();
    }, [ props.actions]);

    return <>
        <div className="with-top-margin">
            Okta domain set in Okta Authentication Settings will be linked to your PPM Express tenant.
        </div>
        <div className="with-top-margin">
            <PrimaryButton text="Link"
                className="with-top-margin"
                onClick={toggleShowConfirmation} />
        </div>
        {showConfirmation && <PromptConfirmationDialog
            title="Link Organization"
            description="Are you sure you want to link your PPM Express tenant to Okta organization as default authentication option?"
            warning="Please note that this action is irreversible, and it will not be possible to unlink organization once the change is made."
            passphrase="CONFIRM"
            onConfirm={linkToOrganization}
            onDismiss={toggleShowConfirmation} />}
    </>
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return {
    };
}

export default connect(mapStateToProps, actionCreators)(OktaOrganizationConnectControl);